import type { Lang } from "../lib/prefs";

// The shared language + theme icon buttons used on the login and app chrome.
export function PrefsToggles({
  lang,
  toggleLang,
  toggleTheme,
}: {
  lang: Lang;
  toggleLang: () => void;
  toggleTheme: () => void;
}) {
  return (
    <>
      <button
        className="iconbtn"
        onClick={toggleLang}
        aria-label="English / Español"
        title="English / Español"
      >
        {lang === "es" ? "EN" : "ES"}
      </button>
      <button
        className="iconbtn"
        onClick={toggleTheme}
        aria-label={lang === "es" ? "Tema" : "Theme"}
        title={lang === "es" ? "Tema" : "Theme"}
      >
        ◐
      </button>
    </>
  );
}
